import { useState, useCallback, useEffect } from "react";
import { toast } from "react-toastify";
import ClassService from "../../../../services/class_service";
import ActivityService from "../../../../services/activity_service";
import AreaService from "../../../../services/area_service";
import EmployeeService from "../../../../services/employee_service";


export const useClassesData = (idTenant, tenantLoading) => {
    const [classes, setClasses] = useState([]);
    const [activities, setActivities] = useState([]);
    const [areas, setAreas] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [isInitialLoading, setIsInitialLoading] = useState(true);

    const loadData = useCallback(async () => {
        if (!idTenant) return;
        setIsInitialLoading(true);

        try {
            const [classesResult, activitiesResult, areasResult, employeesResult] = await Promise.allSettled([
                ClassService.getClasses(idTenant),
                ActivityService.getActivities(idTenant),
                AreaService.getAreas(idTenant),
                EmployeeService.getEmployees(idTenant),
            ]);

            const classesData = classesResult.status === "fulfilled" ? classesResult.value : [];
            const activitiesData = activitiesResult.status === "fulfilled" ? activitiesResult.value : [];
            const areasData = areasResult.status === "fulfilled" ? areasResult.value : [];
            const employeesData = employeesResult.status === "fulfilled" ? employeesResult.value : [];

            setClasses(classesData);
            setActivities(activitiesData.filter(a => a.status === "active"));
            setAreas(areasData.filter(a => a.status === "active"));
            setEmployees(employeesData.filter(e => e.status !== "inactive"));
        } catch (error) {
            console.error("Erro ao carregar dados:", error);
            toast.error("Erro ao carregar dados.");
        } finally {
            setIsInitialLoading(false);
        }
    }, [idTenant]);

    useEffect(() => {
        if (!tenantLoading && idTenant) {
            loadData();
        }
    }, [tenantLoading, idTenant, loadData]);

    return {
        classes,
        activities,
        areas,
        employees,
        isInitialLoading,
        loadData
    };
};
